import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger
} from "@fluentui/react-components";

interface DeleteUserDialogProps {
  disabled?: boolean;
  email: string;
  onConfirm: () => Promise<void>;
}

export const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({ disabled, email, onConfirm }) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={(_, data) => setOpen(data.open)}>
      <DialogTrigger disableButtonEnhancement>
        <Button appearance="subtle" disabled={disabled}>
          Remove
        </Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Remove user</DialogTitle>
          <DialogContent>
            Remove <strong>{email}</strong> from the subscription and free the assigned seat.
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">
                Cancel
              </Button>
            </DialogTrigger>
            <Button
              appearance="primary"
              onClick={async () => {
                await onConfirm();
                setOpen(false);
              }}
            >
              Confirm removal
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
